module.exports = __webpack_public_path__ + "img/SPORTINGBET.5f33f751.svg";